/**
 * Widget contacts rapides : liste des personnes à joindre avec accès téléphone.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WidgetShell } from "./WidgetShell";

export type ContactItem = {
  id: string;
  name: string;
  role: string;
  initials: string;
};

export type ContactsWidgetProps = {
  contacts?: ContactItem[];
};

const DEFAULT_CONTACTS: ContactItem[] = [
  { id: "1", name: "Jean-Paul DEAN", role: "Technicien", initials: "JD" },
  { id: "2", name: "Marie LEROY", role: "Responsable site", initials: "ML" },
  { id: "3", name: "Sophie MARTIN", role: "Vétérinaire", initials: "SM" },
];

export const ContactsWidget = ({
  contacts = DEFAULT_CONTACTS,
}: ContactsWidgetProps) => {
  return (
    <WidgetShell title="Contacts rapides">
      <ul className="space-y-3">
        {contacts.map((contact) => (
          <li
            key={contact.id}
            className="flex items-center gap-3 py-1 border-b border-grey-light last:border-0"
          >
            <div className="w-10 h-10 rounded-full bg-tertiary text-secondary-text flex items-center justify-center text-sm font-oxaniumMedium shrink-0">
              {contact.initials}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-oxaniumMedium text-default-text truncate">
                {contact.name}
              </p>
              <p className="text-xs text-grey-medium">{contact.role}</p>
            </div>
            <button
              type="button"
              className="w-9 h-9 rounded-full bg-secondary/20 text-tertiary flex items-center justify-center shrink-0 hover:bg-secondary/40"
              aria-label={`Appeler ${contact.name}`}
            >
              <FontAwesomeIcon icon="phone" className="text-sm" />
            </button>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="text-sm text-secondary font-medium mt-3 hover:underline"
      >
        Voir tous les contacts →
      </button>
    </WidgetShell>
  );
};
